export const contraloriarole = {
  path: '/contraloria',
  redirect: 'noredirect',
  name: 'Alcalde',
  single: false,
  meta: {
    title: 'CONTRALORIA',
    icon: 'audit',
    roles: ['super', 'admin', 'auditoria']
  }
}
export default contraloriarole
